import { render, staticRenderFns } from "./DataDemo.vue?vue&type=template&id=0a8d0abc&scoped=true&"
import script from "./DataDemo.vue?vue&type=script&lang=js&"
export * from "./DataDemo.vue?vue&type=script&lang=js&"
import style0 from "./DataDemo.vue?vue&type=style&index=0&id=0a8d0abc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d0abc",
  null
  
)

export default component.exports